import React from 'react';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';

//utils
import queries from '../../../utils/queries'

import HomeFact1 from './homefact1';
import HomeFact2 from './homefact2';

import FactProcFact1 from './factprocfact1';
import FactProcFact2 from './factprocfact2';
import FactIFact1 from './factifact1';
import FactIFact2 from './factifact2';
import FactMF1 from './factmf1';
import FactMF2 from './factmf2';
import FactIDC1 from './factidc1';
import FactIDC2 from './factidc2';
import FactEC1 from './factec1';
import FactEC2 from './factec2';
import FactEC2_BV from './factec2_bv';
import FactONE1 from './factone1';
import FactONE2 from './factone2';
import FactElimONE1 from './factelimone1';
import FactElimONE2 from './factelimone2';

import FactProcFactDX1 from './factprocfactdx1';
import FactProcFactDX2 from './factprocfactdx2';

import FactRFact1 from './factrfact1';
import FactRFact2 from './factrfact2';
import AddRFact1 from './addrfact1';
import AddRFact2 from './addrfact2';
import VerRFact1 from './verrfact1';
import VerRfact2 from './verrfact2';

class HomeFact extends React.Component{
  state={
    showFact: true,
    showProcFact: false, showProcFactDX: false, showIFact: false, showMF: false, showIDC: false,
    showEC: false, showOnepay: false, showElimOnepay: false, showRFact: false, addRFact: false, verRFact: false,
    permiteUpdate: false, permiteDelete: false,
    argsAdd: {}, errorAdd: [], argsBuscCliente: {}, argsBuscar: {}, stEntro: 0,
    idLista: {},
  }

  validarHandle = (campo1, campo1Val, campo1Sel, campo1Msg,
    campo2, campo2Val, campo2Sel, campo2Msg,
    campo3, campo3Val, campo3Sel, campo3Msg,
    campo4, campo4Val, campo4Sel, campo4Msg,
    campo5, campo5Val, campo5Sel, campo5Msg,
    campo6, campo6Val, campo6Sel, campo6Msg,
    campo7, campo7Val, campo7Sel, campo7Msg)=>{

    const argsAdd = this.state.argsAdd
    const errors = [];

    if(campo1!=='XXX' && (!campo1 || campo1===campo1Sel)){
      argsAdd[campo1Val] = campo1Sel;
      errors.push({path: campo1Val, message: campo1Msg});
    }
    if(campo2!=='XXX' && (!campo2 || campo2===campo2Sel)){
      argsAdd[campo2Val] = campo2Sel;
      errors.push({path: campo2Val, message: campo2Msg});
    }
    if(campo3!=='XXX' && (!campo3 || campo3===campo3Sel)){
      argsAdd[campo3Val] = campo3Sel;
      errors.push({path: campo3Val, message: campo3Msg});
    }
    if(campo4!=='XXX' && (!campo4 || campo4===campo4Sel)){
      argsAdd[campo4Val] = campo4Sel;
      errors.push({path: campo4Val, message: campo4Msg});
    }
    if(campo5!=='XXX' && (!campo5 || campo5===campo5Sel)){
      argsAdd[campo5Val] = campo5Sel;
      errors.push({path: campo5Val, message: campo5Msg});
    }
    if(campo6!=='XXX' && (!campo6 || campo6===campo6Sel)){
      argsAdd[campo6Val] = campo6Sel;
      errors.push({path: campo6Val, message: campo6Msg});
    }
    if(campo7!=='XXX' && (!campo7 || campo7===campo7Sel)){
      argsAdd[campo7Val] = campo7Sel;
      errors.push({path: campo7Val, message: campo7Msg});
    }
    this.setState({argsAdd});
    this.setState({errorAdd: errors})
  }

  estadosFalse = () => {
    this.setState({argsAdd: {}})
    this.setState({errorAdd: []})

    Object.values(this.state).forEach((estado, i) => {
      if(estado===true){
        this.setState({ [Object.getOwnPropertyNames(this.state)[i]]: false })
      }
    })
  }

  ordenarArrayAsc = (array, campo) => {
    array.sort(function (a, b) {
       return a[campo] > b[campo];
    });
  }

  showFact = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showFact: true})
  }

  selCiudad = () => {
    if(this.props.allDirmayor.allDirmayor){
      const argsAdd = this.state.argsAdd

      let listaDir = this.props.allDirmayor.allDirmayor
      if(this.props.codigoDptoUA!=="Todos..."&&this.props.codigoCiudadUA==="Todas..."){
        listaDir = listaDir.filter(elemento => elemento.codigoDpto===this.props.codigoDptoUA)
        argsAdd['codigoDpto'] = listaDir[0].codigoDpto
        argsAdd['descrDpto'] = listaDir[0].descrDpto
        argsAdd['_id'] = listaDir[0]._id
        this.setState({argsAdd});
      }
      if(this.props.codigoCiudadUA!=="Todas..."){
        let dptoOK = false
        listaDir.forEach((elemento, _id) => {
          if(!dptoOK){
            elemento.ciudades.forEach((elemento1, _id) => {
              if(elemento1.codigoCiudad===this.props.codigoCiudadUA){
                dptoOK = true
                argsAdd['codigoDpto'] = elemento.codigoDpto
                argsAdd['descrDpto'] = elemento.descrDpto
                argsAdd['_id'] = elemento._id
                argsAdd['nombreCiudad'] = elemento1.nombreCiudad
                argsAdd['codigoCiudad'] = elemento1.codigoCiudad
                this.setState({argsAdd});
                // console.log(argsAdd)
              }
            })
          }
        })
      }
    }
  }

  showProcFact = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showProcFact: true})

    this.selCiudad()
  }

  showProcFactDX = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showProcFactDX: true})

    this.selCiudad()
  }

  showIFact = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showIFact: true})
    
    this.selCiudad()
  }

  showMF = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showMF: true})
  }

  showIDC = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showIDC: true})
    
    this.selCiudad()
  }

  showEC = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showEC: true})
    
    this.selCiudad()
  }

  showOnepay = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showOnepay: true})
    
    this.selCiudad()
  }

  showElimOnepay = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showElimOnepay: true})
    
    this.selCiudad()
  }

  showRFact = (ev) => {
    ev.preventDefault()
    this.props.allRangoFact.refetch()
    this.estadosFalse()
    this.setState({showRFact: true})
  }

  addRFact = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({addRFact: true})

    const argsAdd = this.state.argsAdd
    argsAdd['estadoRangoFact'] = false
    this.setState({argsAdd});
  }

  verRFact = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({verRFact: true})
  }

  handleChange = (ev)=>{
    // console.log(ev.target.value)
    // console.log(ev.target.checked)
    const argsAdd = this.state.argsAdd
    if(ev.target.type==='checkbox'){
      argsAdd[ev.target.name] = ev.target.checked
    }else{
      argsAdd[ev.target.name] = ev.target.value
    }
    this.setState({argsAdd});
  }

  handleChangeBuscFact = (ev)=>{
    const argsBuscCliente = this.state.argsBuscCliente
    argsBuscCliente[ev.target.name] = ev.target.value
    this.setState({argsBuscCliente});
  }

  handleBuscCliente = async (ev, args) => {
    ev.preventDefault()

    let argsBuscar={}

    if(args.contrato){
      argsBuscar.contrato=args.contrato
    }else{
      argsBuscar.contrato=null
    }
    if(args.nombreCliente){
      argsBuscar.nombreCliente=args.nombreCliente
    }else{
      argsBuscar.nombreCliente=null
    }
    if(args.apellidoCliente){
      argsBuscar.apellidoCliente=args.apellidoCliente
    }else{
      argsBuscar.apellidoCliente=null
    }
    if(args.descrDpto){
      argsBuscar.descrDpto=args.descrDpto
    }else{
      argsBuscar.descrDpto=null
    }
    if(args.nombreCiudad){
      argsBuscar.nombreCiudad=args.nombreCiudad
    }else{
      argsBuscar.nombreCiudad=null
    }
    if(args.nombreZona){
      argsBuscar.nombreZona=args.nombreZona
    }else{
      argsBuscar.nombreZona=null
    }
    if(args.nombreBarrio){
      argsBuscar.nombreBarrio=args.nombreBarrio
    }else{
      argsBuscar.nombreBarrio=null
    }

    this.setState({argsBuscar});
    // await this.props.allCliBasico.refetch(argsBuscar)
  }


  // if((!args.codigoTarifa||!args.descrTarifa||
  //   ((!args.cicloFact||args.cicloFact==="Seleccionar")&&this.props.comoAsigCicloFact==="Asignarlo a una tarifa y automáticamente al cliente cuando se le asigne tarifa")) && !this.state.permiteDelete){
  //   const argsAdd = this.state.argsAdd
  //   const errors = [];
  //   if(!args.codigoTarifa){
  //     argsAdd['codigoTarifa'] = "";
  //     errors.push({path: 'codigoTarifa', message: "Debe escribir el código"});
  //   }
  //   if(!args.descrTarifa){
  //     argsAdd['descrTarifa'] = "";
  //     errors.push({path: 'descrTarifa', message: "Debe escribir la descripción"});
  //   }
  //   if((!args.cicloFact||args.cicloFact==="Seleccionar")&&this.props.comoAsigCicloFact==="Asignarlo a una tarifa y automáticamente al cliente cuando se le asigne tarifa"){
  //     argsAdd['cicloFact'] = "";
  //     errors.push({path: 'cicloFact', message: "Debe seleccionar elciclo de facturación"});
  //   }
  //   this.setState({argsAdd});
  //   this.setState({errorAdd: errors})




  handleRangoFact = async (ev, args)=>{
    // console.log(args)
    if((!args.factInicial||!args.factFinal||!args.fecha||
        !args.numResolucion||!args.observaciones||!args.cicloFact||args.cicloFact==="Seleccionar...")
      && !this.state.permiteDelete){

      let sinCampo='XXX'
      this.validarHandle(args.factInicial, 'factInicial', '', 'Debe escribir el número inicial de la factura',
                        args.factFinal, 'factFinal', '', 'Debe escribir el número final de la factura',
                        args.cicloFact, 'cicloFact', '', 'Debe seleccionar el ciclo de facturación',
                        args.fecha, 'fecha', '', 'Debe indicar la fecha',
                        args.numResolucion, 'numResolucion', '', 'Debe escribir la resolución',
                        args.observaciones, 'observaciones', '', 'Debe escribir las observaciones',
                        sinCampo, '', '', '')
    }else{
      if(this.state.addRFact){
        let argsAddRF = args
        // argsAddRF['proxFact'] = args.factInicial
        const response = await this.props.createRangoFact({
          variables: argsAddRF
        });
        const {errors, success} = response.data.createRangoFact;
        if (!success){
          this.setState({errorAdd: errors})
        }else{
          var prefijo = document.getElementById("prefijo");
          var factInicial = document.getElementById("factInicial");
          var factFinal = document.getElementById("factFinal");
          var proxFact = document.getElementById("proxFact");
          var cicloFact = document.getElementById("miListaCF");
          cicloFact.options.selectedIndex = 0
          var numResolucion = document.getElementById("numResolucion");
          var observaciones = document.getElementById("observaciones");
          // var estadoRangoFact = document.getElementById("estadoRangoFact");
          prefijo.value = ""
          factInicial.value = ""
          factFinal.value = ""
          proxFact.value = ""
          numResolucion.value = ""
          observaciones.value = ""
          // estadoRangoFact.checked = false   => NO funciona => ???
          this.setState({errorAdd: []})
          const argsAdd = {}
          argsAdd['estadoRangoFact'] = false
          this.setState({argsAdd});
          this.props.allRangoFact.refetch()
        }
      }else{
        if(this.state.permiteUpdate){
          const argsUpd = {
            _id: args._id,
            tipoAct: "EditarRango",
            prefijo: args.prefijo,
            proxFact: args.proxFact,
            cicloFact: args.cicloFact,
            fecha: args.fecha,
            numResolucion: args.numResolucion,
            observaciones: args.observaciones,
            estadoRangoFact: args.estadoRangoFact,
          }
          // console.log(argsUpd)
          const response = await this.props.editRangoFact({
            variables: argsUpd
          });
          const {errors, success} = response.data.editRangoFact;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            this.props.allRangoFact.refetch()
            this.estadosFalse()
            this.setState({showRFact: true})
          }
        }
        if(this.state.permiteDelete){
          const argsDel = {
            _id: args._id
          }
          await this.props.deleteRangoFact({
            variables: argsDel
          });
          this.props.allRangoFact.refetch()
          this.estadosFalse()
          this.setState({showRFact: true})
        }
      }
    }
  }

  handleCiudadDpto = () => {
    this.setState({argsAdd: {}})
    let miLista = document.getElementById("miLista");
    const argsAdd = this.state.argsAdd
    argsAdd['codigoDpto'] = miLista.options[miLista.selectedIndex].attributes[0].value
    argsAdd['descrDpto'] = miLista.options[miLista.selectedIndex].text
    argsAdd['_id'] = miLista.options[miLista.selectedIndex].value
    this.setState({argsAdd});
  }

  handleZonaCiudad = () => {
    var miLista = document.getElementById("miLista1");
    const argsAdd = this.state.argsAdd
    argsAdd['nombreCiudad'] = miLista.options[miLista.selectedIndex].text
    if(miLista.options[miLista.selectedIndex].text==="Todas..."){
      argsAdd['codigoCiudad'] = ""
      argsAdd['codigoCiudadInterno'] = ""
      argsAdd['codBarrasRdo'] = ""
    }else{
      argsAdd['codigoCiudad'] = miLista.options[miLista.selectedIndex].value
      argsAdd['codigoCiudadInterno'] = miLista.options[miLista.selectedIndex].attributes[1].value
      argsAdd['codBarrasRdo'] = miLista.options[miLista.selectedIndex].attributes[2].value
    }
    this.setState({argsAdd});
  }

  handleBarrioZona = () => {
    var miLista = document.getElementById("miLista2");
    const argsAdd = this.state.argsAdd
    argsAdd['nombreZona'] = miLista.options[miLista.selectedIndex].text
    argsAdd['codigoZona'] = miLista.options[miLista.selectedIndex].value
    this.setState({argsAdd});
  }

  handleBarrioSel = () => {
    var miLista = document.getElementById("miLista3");
    const argsAdd = this.state.argsAdd
    argsAdd['nombreBarrio'] = miLista.options[miLista.selectedIndex].text
    argsAdd['codigoBarrio'] = miLista.options[miLista.selectedIndex].value
    argsAdd['codigoTipoDocT'] = miLista.options[miLista.selectedIndex].attributes[0].value
    argsAdd['numeroDocumT'] = miLista.options[miLista.selectedIndex].attributes[1].value
    argsAdd['descrRecursoT'] = miLista.options[miLista.selectedIndex].attributes[2].value
    argsAdd['codigoTipoDocR'] = miLista.options[miLista.selectedIndex].attributes[3].value
    argsAdd['numeroDocumR'] = miLista.options[miLista.selectedIndex].attributes[4].value
    argsAdd['descrRecursoR'] = miLista.options[miLista.selectedIndex].attributes[5].value

    // //si miLista.options[miLista.selectedIndex].attributes[0] no existe pone codigoBarrio que es el value
    // //=> se valida por miLista.options[miLista.selectedIndex].attributes[1]
    // argsAdd['codigoTipoDocT'] = miLista.options[miLista.selectedIndex].attributes[1]?miLista.options[miLista.selectedIndex].attributes[0].value:null
    // argsAdd['numeroDocumT'] = miLista.options[miLista.selectedIndex].attributes[1]?miLista.options[miLista.selectedIndex].attributes[1].value:null
    // argsAdd['descrRecursoT'] = miLista.options[miLista.selectedIndex].attributes[2]?miLista.options[miLista.selectedIndex].attributes[2].value:null
    // argsAdd['codigoTipoDocR'] = miLista.options[miLista.selectedIndex].attributes[3]?miLista.options[miLista.selectedIndex].attributes[3].value:null
    // argsAdd['numeroDocumR'] = miLista.options[miLista.selectedIndex].attributes[4]?miLista.options[miLista.selectedIndex].attributes[4].value:null
    // argsAdd['descrRecursoR'] = miLista.options[miLista.selectedIndex].attributes[5]?miLista.options[miLista.selectedIndex].attributes[5].value:null
// console.log(argsAdd)
    this.setState({argsAdd});
  }

  handleClaseSub = () => {
    var miLista2 = document.getElementById("miLista2");
    const argsAdd = this.state.argsAdd
    argsAdd['descrClaseServ'] = miLista2.options[miLista2.selectedIndex].text
    argsAdd['_idClaseserv'] = miLista2.options[miLista2.selectedIndex].value
    argsAdd['codigoClaseServ'] = miLista2.options[miLista2.selectedIndex].attributes[0].value
    this.setState({argsAdd});
  }

  handleCicloFactCl = () => {
    var miLista = document.getElementById("miListaCF");
    const argsAdd = this.state.argsAdd
    argsAdd['cicloFact'] = miLista.options[miLista.selectedIndex].text
    this.setState({argsAdd});
  }

  idLista = async (ev, idLista)=>{
    // console.log(idLista)
    this.setState({idLista: idLista})
    ev.preventDefault()
    this.estadosFalse()
    if (this.state.showRFact) {
      this.setState({verRFact: true})
    }
  };

  handleClickUpd = (ev) => {
    ev.preventDefault()
    this.setState({permiteUpdate: true, permiteDelete: false})
  }

  handleClickDel = async (ev) => {
    ev.preventDefault()
    this.setState({permiteUpdate: false, permiteDelete: true,})
  }

  // componentDidUpdate(prevProps){
  //   if(this.props.allCliBasico.allCliBasico&&this.state.stEntro<3){
  //     this.setState({stEntro: this.state.stEntro + 1})
  //   }
  //   console.log(this.state.stEntro)
  //   if(this.props.allCliBasico&&this.state.stEntro===1){
  //     console.log("entro ref")
  //     this.props.allCliBasico.refetch()
  //   }
  // }

  render(){
    const {showFact, showProcFact, showProcFactDX, showIFact, showMF, showIDC, showEC, showOnepay,
      showElimOnepay, showRFact, addRFact, verRFact, permiteUpdate, permiteDelete, argsAdd, errorAdd,
      argsBuscCliente, argsBuscar, idLista} = this.state;

      let lista = []
      let lista1 = []
      let lista2 = []
      let lista3 = []
      let fechaIni
// console.log(argsAdd)
      if (this.state.showProcFact||this.state.showProcFactDX||this.state.showIFact||
          this.state.showIDC||this.state.showEC||this.state.showOnepay) {
        if(this.props.allDirmayor.allDirmayor){
          lista1 = this.props.allDirmayor.allDirmayor
          if(this.props.codigoCiudadUA!=="Todas..."){
            let listaD = []
            lista1.forEach((elemento, _id) => {
              if(listaD.length===0){
                elemento.ciudades.forEach((elemento1, _id) => {
                  if(elemento1.codigoCiudad===this.props.codigoCiudadUA){
                    listaD.push(elemento)
                  }
                })
              }
            })
            lista1 = listaD
          }
          // console.log(lista1)
        }
      }

      if (this.state.showProcFact) {
        if(this.props.allClasesServ.allClasesServ){lista2 = this.props.allClasesServ.allClasesServ}
        // if(this.props.allRangoFact.allRangoFact){
        //   lista = this.props.allRangoFact.allRangoFact
        //   lista = lista.filter(elemento => elemento.estadoRangoFact===true)
        // }
      }

      if (this.state.showProcFactDX) {
        if(this.props.allClasesServ.allClasesServ){lista2 = this.props.allClasesServ.allClasesServ}
      }

      if (this.state.showRFact) {
        if(this.props.allRangoFact.allRangoFact){lista = this.props.allRangoFact.allRangoFact}
      }

      if (this.state.showIFact||this.state.showEC||this.state.showOnepay) {
        // console.log("entroIF")
        if(this.props.allRangoFact.allRangoFact){lista = this.props.allRangoFact.allRangoFact}
        // if(this.props.allDirmayor.allDirmayor){lista1 = this.props.allDirmayor.allDirmayor}
        if(this.props.allProcFact.allProcFact){lista2 = this.props.allProcFact.allProcFact}

        if(this.props.allProcFact.allProcFact){
          if(this.props.allProcFact.allProcFact.length>0){
            fechaIni = this.props.allProcFact.allProcFact[this.props.allProcFact.allProcFact.length-1].fechaCreate.substr(0, 10)
          }
        }  
      }
      if (this.state.showIDC||this.state.showIFact) {
        // console.log("entroIF")
        if (this.state.showIDC){
          lista3.push({estadoCli: "DESCONECTADO, SUSPENDIDO o RETIRADO"})
        }
        lista3.push({estadoCli: "DESCONECTADO"})
        lista3.push({estadoCli: "SUSPENDIDO"})
        lista3.push({estadoCli: "RETIRADO"})
        lista3.push({estadoCli: "ACTIVO"})

        // if(this.props.allDirmayor.allDirmayor){lista1 = this.props.allDirmayor.allDirmayor}
        if(this.props.allProcFact.allProcFact){lista2 = this.props.allProcFact.allProcFact}

        if(this.props.allProcFact.allProcFact){
          if(this.props.allProcFact.allProcFact.length>0){
            fechaIni = this.props.allProcFact.allProcFact[this.props.allProcFact.allProcFact.length-1].fechaCreate.substr(0, 10)
          }
        }  
      }

      return (
      <div>
        <div className="ui two column stackable grid">
          <div className="column" style={this.props.styles.boxIzq}>
            {showFact && <HomeFact1 autorizacUA={this.props.autorizacUA} empresa={this.props.empresa}
                        styles={this.props.styles}
                        handleClickSel1={this.showProcFact} handleClickSelPFDX={this.showProcFactDX}
                        handleClickSel5={this.showIFact} handleClickSel6={this.showMF}
                        handleClickElimOnepay={this.showElimOnepay} handleClickOnepay={this.showOnepay}
                        handleClickSel8={this.showIDC} handleClickEC={this.showEC}
                        handleClickSel9={this.showRFact}/>}

            {showRFact && <FactRFact1 styles={this.props.styles} handleClickRegr={this.showFact}/>}
            {addRFact && <AddRFact1 styles={this.props.styles} handleClickRegr={this.showRFact}/>}
            {verRFact && <VerRFact1 autorizacUA={this.props.autorizacUA} styles={this.props.styles} handleClickRegr={this.showRFact} handleClickUpd={this.handleClickUpd} handleClickDel={this.handleClickDel}/>}

            {showProcFact && <FactProcFact1 styles={this.props.styles}
                        handleClickRegr={this.showFact}/>}

            {showProcFactDX && <FactProcFactDX1 styles={this.props.styles}
                        handleClickRegr={this.showFact}/>}

            {showIFact && <FactIFact1 styles={this.props.styles} handleClickRegr={this.showFact} />}
            {/* {showIFact && <FactIFact1 styles={this.props.styles} handleClickRegr={this.showFact}
                              args={argsBuscCliente} handleSubmit={this.handleBuscCliente}
                              handleChange={this.handleChangeBuscFact} />} */}
            {showMF && <FactMF1 styles={this.props.styles} handleClickRegr={this.showFact}/>}
            {showIDC && <FactIDC1 styles={this.props.styles} handleClickRegr={this.showFact}
                              args={argsBuscCliente} handleSubmit={this.handleBuscCliente}
                              handleChange={this.handleChangeBuscFact} />}

            {showEC && <FactEC1 styles={this.props.styles} handleClickRegr={this.showFact} />}
            {showOnepay && <FactONE1 styles={this.props.styles} handleClickRegr={this.showFact} />}
            {showElimOnepay && <FactElimONE1 styles={this.props.styles} handleClickRegr={this.showFact} />}
          </div>
          <div className="column" style={this.props.styles.boxDer}>
            {showFact && <HomeFact2 styles={this.props.styles}/>}
            
            {showRFact && <FactRFact2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} handleClick={this.addRFact} list={lista} handleClickidLista={this.idLista}/>}
            {addRFact && <AddRFact2 styles={this.props.styles} handleSubmit={this.handleRangoFact}
               listaCF={this.props.listaCF} handleLista={this.handleCicloFactCl}
              handleChange={this.handleChange} args={argsAdd} errors={errorAdd} />}
            {verRFact && <VerRfact2 styles={this.props.styles} handleSubmit={this.handleRangoFact}
               listaCF={this.props.listaCF}
              args={argsAdd} errors={errorAdd} idLista={idLista}
              permiteUpdate={permiteUpdate} permiteDelete={permiteDelete}/>}

            {showProcFact && <FactProcFact2 styles={this.props.styles} prefijoFact={this.props.prefijoFact}
                              list1={lista1} listaCF={this.props.listaCF}
                              list2={lista2} handleLista={this.handleCiudadDpto}
                              codigoCiudadUA={this.props.codigoCiudadUA} codigoDptoUA={this.props.codigoDptoUA}
                              handleLista1={this.handleZonaCiudad} handleLista2={this.handleBarrioZona}
                              handleLista3={this.handleClaseSub}
                              argsSelDpto={argsAdd} argsRangoFact={argsAdd}
                              empresa={this.props.empresa} 
                              handleClickRegr={this.showFact}/>}

            {showProcFactDX && <FactProcFactDX2 styles={this.props.styles} prefijoFact={this.props.prefijoFact}
                              list1={lista1} listaCF={this.props.listaCF}
                              list2={lista2} handleLista={this.handleCiudadDpto}
                              codigoCiudadUA={this.props.codigoCiudadUA} codigoDptoUA={this.props.codigoDptoUA}
                              handleLista1={this.handleZonaCiudad} handleLista2={this.handleClaseSub}
                              argsSelDpto={argsAdd} argsRangoFact={argsAdd}
                              handleClickRegr={this.showFact}/>}

            {showIFact && <FactIFact2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} argsBuscar={argsBuscar}
                              args={argsBuscCliente} list={lista} list1={lista1} list2={lista2} list3={lista3} 
                              codigoCiudadUA={this.props.codigoCiudadUA} codigoDptoUA={this.props.codigoDptoUA}
                              handleLista={this.handleCiudadDpto} handleLista1={this.handleZonaCiudad}
                              handleLista2={this.handleBarrioZona} handleLista3={this.handleBarrioSel}
                              argsSelDpto={argsAdd}
                              empresa={this.props.empresa} codBarrasRdo={this.props.codBarrasRdo}
                              fechaIni={fechaIni}/>}
            {showMF && <FactMF2 autorizacUA={this.props.autorizacUA} styles={this.props.styles}
                              codigoCiudadUA={this.props.codigoCiudadUA} codigoDptoUA={this.props.codigoDptoUA}/>}
            {showIDC && <FactIDC2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} argsBuscar={argsBuscar}
                              args={argsBuscCliente} list={lista3} list1={lista1} list2={lista2}
                              codigoCiudadUA={this.props.codigoCiudadUA} codigoDptoUA={this.props.codigoDptoUA}
                              listaCF={this.props.listaCF} listaRec={this.props.listaRec} fechaIni={fechaIni}
                              handleLista={this.handleCiudadDpto} handleLista1={this.handleZonaCiudad}
                              handleLista2={this.handleBarrioZona} handleLista3={this.handleBarrioSel}
                              argsSelDpto={argsAdd} argsSelCiu={argsAdd} argsSelZon={argsAdd}
                              empresa={this.props.empresa} codBarrasRdo={this.props.codBarrasRdo}/>}
            
            {(showEC&&this.props.empresa.empresaArchFE!=="codisert") && <FactEC2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} argsBuscar={argsBuscar}
                              args={argsBuscCliente} list={lista} list1={lista1} list2={lista2}
                              codigoCiudadUA={this.props.codigoCiudadUA} codigoDptoUA={this.props.codigoDptoUA}
                              handleLista={this.handleCiudadDpto} handleLista1={this.handleZonaCiudad}
                              handleLista2={this.handleBarrioZona} handleLista3={this.handleBarrioSel}
                              argsSelDpto={argsAdd}
                              empresa={this.props.empresa} codBarrasRdo={this.props.codBarrasRdo}
                              fechaIni={fechaIni}/>}
            {(showEC&&this.props.empresa.empresaArchFE==="codisert") && <FactEC2_BV autorizacUA={this.props.autorizacUA} styles={this.props.styles} argsBuscar={argsBuscar}
                              args={argsBuscCliente} list={lista} list1={lista1} list2={lista2}
                              codigoCiudadUA={this.props.codigoCiudadUA} codigoDptoUA={this.props.codigoDptoUA}
                              handleLista={this.handleCiudadDpto} handleLista1={this.handleZonaCiudad}
                              handleLista2={this.handleBarrioZona} handleLista3={this.handleBarrioSel}
                              argsSelDpto={argsAdd}
                              empresa={this.props.empresa} codBarrasRdo={this.props.codBarrasRdo}
                              fechaIni={fechaIni}/>}
            {showOnepay && <FactONE2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} argsBuscar={argsBuscar}
                              args={argsBuscCliente} list={lista} list1={lista1} list2={lista2}
                              codigoCiudadUA={this.props.codigoCiudadUA} codigoDptoUA={this.props.codigoDptoUA}
                              handleLista={this.handleCiudadDpto} handleLista1={this.handleZonaCiudad}
                              handleLista2={this.handleBarrioZona} handleLista3={this.handleBarrioSel}
                              argsSelDpto={argsAdd}
                              empresa={this.props.empresa} codBarrasRdo={this.props.codBarrasRdo}
                              fechaIni={fechaIni}/>}
            {showElimOnepay && <FactElimONE2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} argsBuscar={argsBuscar}
                              args={argsBuscCliente} list={lista} list1={lista1} list2={lista2}
                              codigoCiudadUA={this.props.codigoCiudadUA} codigoDptoUA={this.props.codigoDptoUA}
                              handleLista={this.handleCiudadDpto} handleLista1={this.handleZonaCiudad}
                              handleLista2={this.handleBarrioZona} handleLista3={this.handleBarrioSel}
                              argsSelDpto={argsAdd}
                              empresa={this.props.empresa} codBarrasRdo={this.props.codBarrasRdo}
                              fechaIni={fechaIni}/>}
          </div>
        </div>
      </div>
    )
  }
}

export default compose(
  graphql(queries.query.allRangoFact, {name:'allRangoFact', options: (props) => {return {variables: {}}}}),
  graphql(queries.mutation.createRangoFact, {name:'createRangoFact'}),
  graphql(queries.mutation.editRangoFact, {name:'editRangoFact'}),
  graphql(queries.mutation.deleteRangoFact, {name:'deleteRangoFact'}),

  graphql(queries.query.allDirmayor, {name:'allDirmayor', options: (props) => {return {variables: {}}}}),
  graphql(queries.query.allClasesServ, {name:'allClasesServ'}),
  graphql(queries.query.allProcFact, {name:'allProcFact', options: (props) => {return {variables: {}}}}),

  // graphql(queries.query.allCliBasico, {name:'allCliBasico', options: (props) => {return {variables: {contrato: "XYZ321"}}}}),
  )(HomeFact)
